import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en-US',
  interpolation: {
    escapeValue: false
  },
  resources: {
    'en-US': {
      translation: {
        TitleBestWorstPerf: 'Best and Worst Performers',
        TitleDailyPerf: 'Daily Performance Explained',
        TitleShortLevFAQ: 'Short & Leveraged ETP SmartFAQ',
        TitleShortLevSim: 'Short & Leveraged ETP Simulator',
        TitleDPD: 'Digital Portfolio Developer',
        TitleEcoCal: 'Economic Calendar',
        DescribeBestWorstPerf: 'Compare our best and worst performing unleveraged ETPs.',
        DescribeDailyPerf: 'Have a question about a specific product’s performance? See our new tool covering our synthetic ETC range.',
        DescribeShortLevFAQ: 'Ask us anything about Short & Leveraged ETPs using our SmartFAQ.',
        DescribeShortLevSim: 'Use our S&L simulator to model returns of an S&L ETP across various market scenarios.',
        DescribeDPD: 'Create a theoretical investment portfolio analysing various factors including risk-adjusted returns, income or expenses.',
        DescribeEcoCal: 'Stay current on recent and upcoming market events with our economic calendar',
        Register: 'Register',
        SignIn: 'Sign In',
      }
    },
    'en-GB': {
      translation: {
        TitleBestWorstPerf: 'Best and Worst Performers',
        TitleDailyPerf: 'Daily Performance Explained',
        TitleShortLevFAQ: 'Short & Leveraged ETP SmartFAQ',
        TitleShortLevSim: 'Short & Leveraged ETP Simulator',
        TitleDPD: 'Digital Portfolio Developer',
        TitleEcoCal: 'Economic Calendar',
        DescribeBestWorstPerf: 'Compare our best and worst performing unleveraged ETPs.',
        DescribeDailyPerf: 'Have a question about a specific product’s performance? See our new tool covering our synthetic ETC range.',
        DescribeShortLevFAQ: 'Ask us anything about Short & Leveraged ETPs using our SmartFAQ.',
        DescribeShortLevSim: 'Use our S&L simulator to model returns of an S&L ETP across various market scenarios.',
        DescribeDPD: 'Create a theoretical investment portfolio analysing various factors including risk-adjusted returns, income or expenses.',
        DescribeEcoCal: 'Stay current on recent and upcoming market events with our economic calendar',
        Register: 'Register',
        SignIn: 'Sign In',
      }
    },
    'it-IT': {
      translation: {
        TitleBestWorstPerf: 'Performance migliori e performance peggiori ',
        TitleDailyPerf: 'Spiegazione della performance giornaliera ',
        TitleShortLevFAQ: 'SmartFAQ sugli ETP S&L',
        TitleShortLevSim: 'Simulatore di ETP S&L ',
        TitleDPD: 'Sviluppatore del portafoglio digitale ',
        TitleEcoCal: 'Calendario economico',
        DescribeBestWorstPerf: 'Confronta le performance migliori e quelle peggiori dei nostri prodotti ETP senza effetto leva.',
        DescribeDailyPerf: 'Domande sulla performance di un prodotto specifico? Vai a vedere il nuovo tool che copre la nostra gamma di prodotti ETC sintetici.',
        DescribeShortLevFAQ: 'Chiedici qualunque cosa sugli ETP short e leverage usando le nostre ETP SmartFAQ.',
        DescribeShortLevSim: 'Usa il nostro simulatore S&L per realizzare un modello dei rendimenti di un ETP S&L in diversi scenari di mercato',
        DescribeDPD: 'Create a theoretical investment portfolio analysing various factors including risk-adjusted returns, income or expenses.',
        DescribeEcoCal: 'Tieniti aggiornato sugli ultimi e i prossimi eventi di mercato con il nostro calendario economico. ',
        Register: 'Registrati ',
        SignIn: 'Accedi ',
      }
    },
    'it-CH': {
      translation: {
        TitleBestWorstPerf: 'Performance migliori e performance peggiori ',
        TitleDailyPerf: 'Spiegazione della performance giornaliera ',
        TitleShortLevFAQ: 'SmartFAQ sugli ETP S&L',
        TitleShortLevSim: 'Usa il nostro simulatore S&L per realizzare un modello dei rendimenti di un ETP S&L in diversi scenari di mercato',
        TitleDPD: 'Sviluppatore del portafoglio digitale ',
        TitleEcoCal: 'Calendario economico',
        DescribeBestWorstPerf: 'Confronta le performance migliori e quelle peggiori dei nostri prodotti ETP senza effetto leva.',
        DescribeDailyPerf: 'Domande sulla performance di un prodotto specifico? Vai a vedere il nuovo tool che copre la nostra gamma di prodotti ETC sintetici.',
        DescribeShortLevFAQ: 'Chiedici qualunque cosa sugli ETP short e leverage usando le nostre ETP SmartFAQ.',
        DescribeShortLevSim: 'Usa il nostro simulatore S&L per realizzare un modello dei rendimenti di un ETP S&L in diversi scenari di mercato',
        DescribeDPD: 'Create a theoretical investment portfolio analysing various factors including risk-adjusted returns, income or expenses.',
        DescribeEcoCal: 'Tieniti aggiornato sugli ultimi e i prossimi eventi di mercato con il nostro calendario economico. ',
        Register: 'Registrati ',
        SignIn: 'Accedi ',
      }
    },
    'de-DE': {
      translation: {
        TitleBestWorstPerf: 'Spitzenreiter und Schlusslichter',
        TitleDailyPerf: 'Details zur täglichen Performance',
        TitleShortLevFAQ: 'S&L ETP SmartFAQ',
        TitleShortLevSim: 'S&L ETP Simulator',
        TitleDPD: 'Digital Portfolio Developer',
        TitleEcoCal: 'Wirtschaftskalender',
        DescribeBestWorstPerf: 'Vergleichen Sie, welche unserer ETPs ohne Hebeleffekt am besten und am schlechtesten abgeschnitten haben.',
        DescribeDailyPerf: 'Sie haben eine Frage zur Performance eines bestimmten Produkts? Dann hilft Ihnen unser neues Tool weiter, das unser Angebot für synthetische ETCs abdeckt.',
        DescribeShortLevFAQ: 'Stellen Sie uns mit SmartFAQ Ihre Fragen zu Short-Leveraged-ETPs.',
        DescribeShortLevSim: 'Nutzen Sie unseren S&L-Simulator zur Modellierung der Renditen eines S&L ETP unter verschiedenen Marktbedingungen.',
        DescribeDPD: 'Erstellen Sie ein theoretisches Investmentportfolio und analysieren Sie es nach verschiedenen Faktoren, wie risikoadjustierte Renditen, Erträge oder Aufwendungen.',
        DescribeEcoCal: 'Bleiben Sie mit unserem Wirtschaftskalender zu aktuellen und anstehenden Marktereignissen auf dem Laufenden.',
        Register: 'Registrieren',
        SignIn: 'Anmelden',
      }
    },
    'de-AT': {
      translation: {
        TitleBestWorstPerf: 'Spitzenreiter und Schlusslichter',
        TitleDailyPerf: 'Details zur täglichen Performance',
        TitleShortLevFAQ: 'S&L ETP SmartFAQ',
        TitleShortLevSim: 'S&L ETP Simulator',
        TitleDPD: 'Digital Portfolio Developer',
        TitleEcoCal: 'Wirtschaftskalender',
        DescribeBestWorstPerf: 'Vergleichen Sie, welche unserer ETPs ohne Hebeleffekt am besten und am schlechtesten abgeschnitten haben.',
        DescribeDailyPerf: 'Sie haben eine Frage zur Performance eines bestimmten Produkts? Dann hilft Ihnen unser neues Tool weiter, das unser Angebot für synthetische ETCs abdeckt.',
        DescribeShortLevFAQ: 'Stellen Sie uns mit SmartFAQ Ihre Fragen zu Short-Leveraged-ETPs.',
        DescribeShortLevSim: 'Nutzen Sie unseren S&L-Simulator zur Modellierung der Renditen eines S&L ETP unter verschiedenen Marktbedingungen.',
        DescribeDPD: 'Erstellen Sie ein theoretisches Investmentportfolio und analysieren Sie es nach verschiedenen Faktoren, wie risikoadjustierte Renditen, Erträge oder Aufwendungen.',
        DescribeEcoCal: 'Bleiben Sie mit unserem Wirtschaftskalender zu aktuellen und anstehenden Marktereignissen auf dem Laufenden.',
        Register: 'Registrieren',
        SignIn: 'Anmelden',
      }
    },
    'de-CH': {
      translation: {
        TitleBestWorstPerf: 'Spitzenreiter und Schlusslichter',
        TitleDailyPerf: 'Details zur täglichen Performance',
        TitleShortLevFAQ: 'S&L ETP SmartFAQ',
        TitleShortLevSim: 'S&L ETP Simulator',
        TitleDPD: 'Digital Portfolio Developer',
        TitleEcoCal: 'Wirtschaftskalender',
        DescribeBestWorstPerf: 'Vergleichen Sie, welche unserer ETPs ohne Hebeleffekt am besten und am schlechtesten abgeschnitten haben.',
        DescribeDailyPerf: 'Sie haben eine Frage zur Performance eines bestimmten Produkts? Dann hilft Ihnen unser neues Tool weiter, das unser Angebot für synthetische ETCs abdeckt.',
        DescribeShortLevFAQ: 'Stellen Sie uns mit SmartFAQ Ihre Fragen zu Short-Leveraged-ETPs.',
        DescribeShortLevSim: 'Nutzen Sie unseren S&L-Simulator zur Modellierung der Renditen eines S&L ETP unter verschiedenen Marktbedingungen.',
        DescribeDPD: 'Erstellen Sie ein theoretisches Investmentportfolio und analysieren Sie es nach verschiedenen Faktoren, wie risikoadjustierte Renditen, Erträge oder Aufwendungen.',
        DescribeEcoCal: 'Bleiben Sie mit unserem Wirtschaftskalender zu aktuellen und anstehenden Marktereignissen auf dem Laufenden.',
        Register: 'Registrieren',
        SignIn: 'Anmelden',
      }
    }
  }
});

export default i18n;



// WEBPACK FOOTER //
// ./src/components/App/i18n.js